class User {
  id;
  firstname;
  lastname;
  email;
  roles;
  hmg;
  assumedUserFullName;
  assumedUserId;
  tpxPermissions;
  productAccess;
  constructor(userData) {
    this.id = userData.id;
    this.firstname = userData.firstname;
    this.lastname = userData.lastname;
    this.email = userData.email;
    this.assumedUserFullName = userData.assumedUserFullName;
    this.assumedUserId = userData.assumedUserId;
    this.tpxPermissions = Array.isArray(userData.tpxPermissions) ? userData.tpxPermissions : [];
    this.productAccess = Array.isArray(userData.productAccess) ? userData.productAccess : [];
    this.roles = (userData.roles || []).map(role => new Role(role));
    this.hmg = (userData.hmg || []).map(hmgItem => new HMG(hmgItem));
  }
}

class Role {
  id;
  name;
  permissions;
  application;
  constructor(role) {
    this.id = role.id;
    this.name = role.name;
    this.permissions = (role.permissions || []).map(
      perm => new Permission(perm.id, perm.name, perm.value)
    );
    // `application` is optional on the server payload — preserve as-is
    // (null/undefined when the role is not scoped to any application).
    // Some API responses use `system` (same semantics as application scope).
    const appScope = role.application || role.system;
    this.application = appScope
      ? new Application(appScope.id, appScope.name)
      : null;
  }
}

class Application {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}

class Permission {
  constructor(id, name, value) {
    this.id = id;
    this.name = name;
    this.value = value;
  }
}

class Property {
  id;
  name;
  timeZone;
  rooms;
  calendarType;
  systems;
  constructor(id, name, rooms, calendarType) {
    this.id = id;
    this.name = name;
    this.rooms = rooms;
    this.calendarType = calendarType;
  }
}

class HMG {
  id;
  name;
  properties;
  isReprocessing;
  constructor(hmgItem) {
    this.id = hmgItem.id;
    this.name = hmgItem.name;
    this.properties = hmgItem.properties.map(
      prop => new Property(prop.id, prop.name, prop.rooms, prop.calendarType)
    );
    this.isReprocessing = hmgItem.isReprocessing;
  }
}

export default User;
